import { render, staticRenderFns } from "./PermissionMask.vue?vue&type=template&id=453e79c2&scoped=true&"
import script from "./PermissionMask.vue?vue&type=script&lang=js&"
export * from "./PermissionMask.vue?vue&type=script&lang=js&"
import style0 from "./PermissionMask.vue?vue&type=style&index=0&id=453e79c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e79c2",
  null
  
)

export default component.exports